import { DefaultLayout } from '_layout/Client';

const ClientLayout = () => {
    return <DefaultLayout />;
}


export default ClientLayout;
